var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.latitude && this.longitude)?_c('div',{ref:"map",staticStyle:{"min-height":"300px"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }